import React from 'react';
import { string, object, number } from 'prop-types';
import setClass from '../../../common/set-class';
const Progress = ({ progress, className, style }) => (React.createElement("div", { style: style, className: setClass(['b-upload__progress-bar', className]) },
    React.createElement("div", { className: `b-upload__progress-bar-loader ${progress < 100 ? 'b-upload__progress-bar-incomplete' : ''}`, style: { width: `${progress}%` } }),
    React.createElement("p", { className: "b-txt-bold b-upload__progress-percent" }, `${progress}%`)));
Progress.propTypes = {
    progress: number,
    className: string,
    style: object,
};
Progress.defaultProps = {
    progress: 0,
    className: '',
    style: {},
};
export default Progress;
